import OnlyGuestRoute from './OnlyGuestRoute';

export default OnlyGuestRoute;
